import { FLAVOR } from '../../flavor/flavor'
import { legalUrl } from '../../lib/legalUrl'
import { PageShell, SectionList, Row } from './SectionList'

const VERSION = import.meta.env.VITE_APP_VERSION ?? 'dev'
const LEGAL_URL = legalUrl(import.meta.env.VITE_API_BASE_URL)

export function LegalPage() {
  return (
    <PageShell title="Legal">
      <SectionList title="App">
        <Row label="Name" value={FLAVOR.appName} />
        <Row label="Version" value={VERSION} />
      </SectionList>
      <SectionList title="Documents">
        <Row
          label="Privacy Policy"
          onClick={() => window.open(LEGAL_URL, '_blank')}
        />
        <Row
          label="Terms of Service"
          onClick={() => window.open(LEGAL_URL, '_blank')}
        />
      </SectionList>
    </PageShell>
  )
}
